import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Index,
    meta: {
      showNavBar: false
    }
  },
  {
    path: '/fill-vincode',
    component: () => import('../views/fill-vincode.vue'),
    meta: {
      showBack: false
    }
  },
  {
    path: '/activation',
    component: () => import('../views/activation.vue'),
    meta: {
      showBack: false
    }
  },
  {
    path: '/activation-info',
    component: () => import('../views/activation-info.vue'),
    meta: {
      showBack: false
    }
  },
  {
    path: '/anti-fake-result',
    component: () => import('../views/anti-fake-result.vue'),
  },
  {
    path: '/:catchAll(.*)',
    name: 'not-found',
    component: () => import('@/views/not-found.vue'),
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
